import React, { useState } from "react";
import { ReactComponent as SubtractLogo } from "../assets/Subtract.svg";
import PremiumInput from "../components/ui/PremiumInput";
import { useAuth } from "../hooks";
import { UI_TEXT } from "../constants/uiText";

interface SignUpViewProps {
  onLogin: (view: string, admin: boolean) => void;
  onSwitchToLogin: () => void;
}

const SignUpView: React.FC<SignUpViewProps> = ({
  onLogin,
  onSwitchToLogin,
}) => {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [dartsLiveCard, setDartsLiveCard] = useState("");
  const { signUp, login, isLoading, error } = useAuth();

  const handleSignUp = async () => {
    const ok = await signUp({
      login_id: loginId,
      password,
      dartslive_card_name: dartsLiveCard,
    });
    if (ok) {
      const { ok: loginOk, isAdmin: admin } = await login({
        login_id: loginId,
        password,
      });
      if (loginOk) onLogin("home", admin);
    }
  };

  return (
    <div className="flex flex-col h-full px-6 py-12 bg-[#f8fafc] relative animate-in fade-in duration-300 overflow-y-auto">
      <div className="flex-1 flex flex-col justify-center max-w-sm mx-auto w-full text-center">
        <div className="mb-10">
          <div className="flex items-center justify-center mx-auto mb-6">
            <SubtractLogo className="w-12 h-[70px]" />
          </div>
          <h1 className="text-3xl font-black tracking-tight mb-2 uppercase text-center bg-gradient-to-r from-slate-900 via-slate-600 to-slate-400 bg-clip-text text-transparent">
            {UI_TEXT.common.appName}
          </h1>
          <p className="text-slate-400 text-xs font-bold tracking-widest uppercase text-center">
            {UI_TEXT.auth.signUp.title}
          </p>
        </div>
        <div className="mb-6">
          <PremiumInput
            type="text"
            placeholder={UI_TEXT.auth.signUp.loginIdPlaceholder}
            label={UI_TEXT.auth.signUp.loginIdLabel}
            value={loginId}
            onChange={(e) => setLoginId(e.target.value)}
          />
          <PremiumInput
            type="password"
            placeholder={UI_TEXT.auth.signUp.passwordPlaceholder}
            label={UI_TEXT.auth.signUp.passwordLabel}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <PremiumInput
            type="text"
            placeholder={UI_TEXT.auth.signUp.dartsLiveCardPlaceholder}
            label={UI_TEXT.auth.signUp.dartsLiveCardLabel}
            value={dartsLiveCard}
            onChange={(e) => setDartsLiveCard(e.target.value)}
          />
          {error && (
            <p className="text-rose-500 text-xs font-bold text-left pl-1 -mt-2 mb-2">
              {error}
            </p>
          )}
          <button
            onClick={handleSignUp}
            disabled={isLoading}
            className="w-full bg-slate-900 text-white font-bold py-4 rounded-lg shadow-lg mt-8 active:scale-95 transition-all uppercase tracking-widest disabled:opacity-50"
          >
            {isLoading ? UI_TEXT.common.loading : UI_TEXT.auth.signUp.submit}
          </button>
          <button
            onClick={onSwitchToLogin}
            className="mt-6 text-slate-400 text-[10px] font-bold tracking-widest uppercase hover:text-slate-600 transition-colors py-2 block mx-auto"
          >
            {UI_TEXT.auth.signUp.toSignIn}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignUpView;
